import React, { useMemo, useState } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStorefrontContext } from 'context/StorefrontContext';
import { STORAGE_KEYS } from 'constants/storageKeys';
import { tenantStorage } from 'utils/tenantStorage';

const CookieBanner: React.FC = () => {
  const { t } = useTranslation('common');
  const { theme } = useStorefrontContext();
  const cookies = theme?.cookies;
  const [accepted, setAccepted] = useState(
    () => tenantStorage.getItem(STORAGE_KEYS.COOKIES_ACCEPTED) === '1'
  );

  const enabled = Boolean(cookies?.enabled);
  const message = useMemo(
    () => cookies?.message?.trim() || t('cookies.message'),
    [cookies?.message, t]
  );
  const acceptLabel = cookies?.acceptLabel?.trim() || t('cookies.accept');

  if (!enabled || accepted) return null;

  const handleAccept = () => {
    tenantStorage.setItem(STORAGE_KEYS.COOKIES_ACCEPTED, '1');
    setAccepted(true);
  };

  return (
    <Box
      role="dialog"
      aria-label={t('cookies.title')}
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: (muiTheme) => muiTheme.zIndex.snackbar,
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        py: 1.5,
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { sm: 'center' },
          gap: 2,
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="body2">{message}</Typography>
        <Button variant="contained" color="inherit" onClick={handleAccept} sx={{ bgcolor: 'common.black', color: 'common.white', flexShrink: 0 }}>
          {acceptLabel}
        </Button>
      </Container>
    </Box>
  );
};

export default CookieBanner;
